import { render, staticRenderFns } from "./edit-ean.vue?vue&type=template&id=138de57a"
import script from "./edit-ean.vue?vue&type=script&lang=ts"
export * from "./edit-ean.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports